import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenRequest } from '../models/tokenrequest.model';
import { Observable } from 'rxjs/observable';
import 'rxjs/add/operator/map';
import { ConfigService } from './configService';
import { EnvironmentSettings } from '../models/environmentsettings.model';

@Injectable()
export class UserService {
    environmentSettings: EnvironmentSettings;
    constructor(private _http: HttpClient) { }
    validateAdminUser(tokenRequest: TokenRequest) {
        this.environmentSettings = new EnvironmentSettings();
        return this._http.post(this.environmentSettings.apiEndPoint + 'api/auth/signin', tokenRequest);
    }
    isAdminUser() {
        let config: any;
        if (localStorage.getItem('app_token') != null) {
            config = JSON.parse(localStorage.getItem('app_token'));
            return config == null ? null : config.isAdmin;
        }
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/user.service.ts